import OverlayContainer from "@components/Overlay/OverlayContainer";
import { useEffect, useState } from "react";
import { FaEdit, FaSort, FaTrash } from "react-icons/fa";
import axiosInstance from "../../../axios";
import Modal from "../../Other/Modal";
import Forms from "./Forms";

function Preview() {
  const [editInstructorData, setEditInstructorData] = useState({});
  const [singlePage, setSinglePage] = useState([]);
  const [modal, setModal] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [previewId, setPreviewId] = useState();
  const [search, setSearch] = useState("");
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");
  const [filter, setFilter] = useState({
    page: 1,
    itemsPerPage: 10,
    status: "",
  });

  const handleClose = () => {
    setModal(false);
    fetchData();
  };

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await axiosInstance.get("/job-transitions", {
        params: {
          page: filter.page,
          itemsPerPage: filter.itemsPerPage,
        },
      });
      setSinglePage(response.data.data);
      setSortField(["id", "quote", "createdAt"]);
      //console.log("singlePage", response.data.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleAddInstructor = () => {
    setEditInstructorData({});
    setModal(true);
  };

  const handleEditInstructor = (data) => {
    setEditInstructorData(data);
    setModal(true);
  };

  const handleDelete = async () => {
    try {
      await axiosInstance.delete(`/job-transitions/${previewId}`);
      setConfirmDelete(false);
      fetchData();
    } catch (error) {
      console.error("Error deleting:", error);
    }
  };

  const handleDeleteInstructor = (id) => {
    setConfirmDelete(true);
    setPreviewId(id);
  };

  // Handle column sort
  const handleSort = (field) => {
    if (sortField === field) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    }
  };

  // Filter data by search
  let filteredData = singlePage
    ? singlePage.filter((ele) =>
      Object.values(ele)
        .join(" ")
        .toLowerCase()
        .includes(search.toLowerCase())
    )
    : [];

  // Sort data
  if (sortField) {
    filteredData = [...filteredData].sort((a, b) => {
      if (a[sortField] < b[sortField]) return sortOrder === "asc" ? -1 : 1;
      if (a[sortField] > b[sortField]) return sortOrder === "asc" ? 1 : -1;
      return 0;
    });
  }

  return (
    <div>
      <div className="dashboard-container-new !mx-5 !mt-10">
        <p>Testimonials</p>
      </div>

      <div className="page-data-new !mx-5">
        <div>
          {singlePage?.length > 0 ? (
            <p className="showing-result">
              Showing {singlePage?.length} results
            </p>
          ) : (
            <p className="showing-result">Showing 0 results</p>
          )}
        </div>
        <div className="flex items-center">
          <label className="text-[#42759d]">
            Search
          </label>
          <input
            type="text"
            placeholder="Search all columns..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="search-input w-[200px]"
            style={{ marginLeft: "10px", padding: "5px" }}
          />

        </div>
        <div className="pagination-flex">
          <button onClick={handleAddInstructor} className="export-btn">
            Add <span>&#10009;</span>
          </button>

          <div className="pagination-select">
            <select
              className="select-dropdown-instructor-2"
              onChange={(e) =>
                setFilter({ ...filter, status: e.target.value })
              }
            >
              <option value="">All</option>
              <option value="0">Pending</option>
              <option value="1">Completed</option>
            </select>
          </div>

          <div className="pagination-select">
            <select
              className="select-dropdown-instructor-1"
              onChange={(e) =>
                setFilter({ ...filter, itemsPerPage: e.target.value })
              }
            >
              {[10, 20, 30, 40, 50].map((size) => (
                <option key={size} value={size}>
                  {size}
                </option>
              ))}
            </select>
          </div>


        </div>
      </div>

      <div className="instructor-table !mx-5">
        {filteredData.length === 0 ? (
          <h2 className="no-data-found">No data found</h2>
        ) : (
          <table className="table-width-100">
            <thead>
              <tr>
                {[
                  { label: "Id", field: "id" },
                  { label: "User Name", field: "name" },
                  { label: "Title", field: "quote" },
                  { label: "Description", field: "description" },
                  { label: "JobName", field: "newJob" },
                  { label: "Created on", field: "createdAt" },
                  { label: "Image", field: null },
                  { label: "Actions", field: null },
                ].map((col, idx) => (
                  <th
                    key={idx}
                    className="cursor-pointer select-none hover:text-blue-600"
                    onClick={() => col.field && handleSort(col.field)}
                  >
                    <div className="flex items-center gap-1 flex">
                      {col.label}
                      {col.field &&
                        (sortField === col.field ? (
                          sortOrder === "asc" ? <FaSortUp /> : <FaSortDown />
                        ) : (
                          <FaSort className="text-gray-400" />
                        ))}
                    </div>
                  </th>

                ))}
              </tr>
            </thead>
            <tbody>
              {filteredData.map((ele, index) => (
                <tr key={index}>
                  <td>{ele.id}</td>
                  <td>{ele.name}</td>
                  <td>{ele.quote}</td>
                  <td>{ele.description}</td>
                  <td>{ele.newJob}</td>
                  <td>{ele.createdAt}</td>
                  <td className="mt-4">
                    <img
                      src={ele.image}
                      alt={ele.image}
                      style={{
                        width: "50px",
                        height: "50px",
                        objectFit: "cover",
                      }}
                    />
                  </td>
                  <td className="flex items-center gap-2 mt-4">
                    <button onClick={() => handleEditInstructor(ele)}>
                      <FaEdit
                        style={{
                          cursor: "pointer",
                          color: "#264b82",
                          fontSize: "18px",
                        }}
                        title="Edit"
                      />
                    </button>
                    <button onClick={() => handleDeleteInstructor(ele.id)}>
                      <FaTrash
                        style={{
                          cursor: "pointer",
                          color: "#264b82",
                          fontSize: "18px",
                        }}
                        title="Delete"
                      />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        {confirmDelete && (
          <OverlayContainer>
            <div className="alert-dialog-inner">
              <div
                className="alert-dialog-close"
                onClick={() => setConfirmDelete(false)}
              >
                <div>
                  <i className="icon check"></i>
                </div>
              </div>
              <div className="alert-title">Warning!</div>
              <div className="alert-message">Delete the Preview</div>
              <div className="alert-close-btn">
                <a className="btn-save" onClick={handleDelete}>
                  OK
                </a>
                <a className="btn-cancel" onClick={() => setConfirmDelete(false)}>
                  CANCEL
                </a>
              </div>
            </div>
          </OverlayContainer>
        )}
      </div>

      {modal && (
        <Modal isOpen={modal} onClose={handleClose}>
          <div className="">
            <Forms
              setModal={handleClose}
              title="Job Transition"
              editData={editInstructorData}
            />
          </div>
        </Modal>
      )}
    </div>
  );
}

export default Preview;
